export default __webpack_public_path__ + "static/media/web3.856221a3.png";